class Session {
    _storageKey
    _payload

    constructor(storageKey = 'csp-company-session') {
        this._storageKey = storageKey

        // try to read a payload
        const payload = this._read()

        if (!payload) {
            // if there is no previous session
            // create a new payload and save it
            this._payload = new SessionPayload()
            this._write(this._payload)
        } else {
            // otherwise use the existing one
            this._payload = payload
        }
    }

    reinit(authTime) {
        this._destroy()
        this._payload = new SessionPayload()
        this._payload.authTime = authTime
        this._write(this._payload)
    }

    _destroy() {
        localStorage.removeItem(this._storageKey)
    }

    get payload() {
        return this._read()
    }

    get authTime() {
        return this._payload.authTime
    }

    set authTime(authTime) {
        this._payload.authTime = authTime
        this._write(this._payload)
    }


    get corporation() {
        return this._payload.corporation
    }

    set corporation(corporation) {
        this._payload.corporation = corporation
        this._write(this._payload)
    }

    get uuidTicketholder() {
        return this._payload.uuidTicketholder
    }

    set uuidTicketholder(uuidTicketholder) {
        this._payload.uuidTicketholder = uuidTicketholder
        this._write(this._payload)
    }

    _write(payload) {
        const payloadString = JSON.stringify(payload)
        localStorage.setItem(this._storageKey, payloadString)
    }

    _read() {
        const payloadString = localStorage.getItem(this._storageKey)
        if (!payloadString) {
            return undefined
        }
        return JSON.parse(payloadString)
    }
}

class SessionPayload {
    authTime
    /** @type {Corporation} */
    corporation

    uuidTicketholder
}

export default Session

export {
    SessionPayload
}